module.exports = __webpack_public_path__ + "assets/img/user.ee79a257.png";